import { useContext, useState } from 'react';
import { Grid, Button, TextField, MenuItem, Tooltip, IconButton } from '@mui/material';
import { MdSearch as SearchIcon, MdOutlineFilterAlt as FilterIcon } from 'react-icons/md';
import { customerTicketsContext } from '../../CustomerTicketsContext';
import { FilterContainer, FiltersMenu } from 'components';
import { useIntl } from 'react-intl';
import { LocalizationIds } from 'helpers/Localizations';


let MobileFilters = () => {

    let { formatMessage } = useIntl();
    let service = useContext(customerTicketsContext);
    let [sidebarIsOpen, setSidebarIsOpen] = useState<boolean>(false);

    return (
        <>
            <Grid container spacing={0}>
                <Grid item xs />
                <Grid item>
                    <Tooltip title={formatMessage({ id: LocalizationIds.ShowFilter })}>
                        <IconButton size="small" onClick={() => { setSidebarIsOpen(false); setSidebarIsOpen(true); }}>
                            <FilterIcon size="24" />
                        </IconButton>
                    </Tooltip>
                </Grid>
            </Grid>
            <FiltersMenu
                caption={formatMessage({ id: LocalizationIds.Filter })}
                menuSide="right"
                sidebarOpen={sidebarIsOpen}
                closeSidebar={() => { setSidebarIsOpen(false); }}
            >
                <FilterContainer onSubmit={() => { service.doSearch(service.search); }}>
                    <Grid item xs={12}>
                        <TextField
                            variant="standard"
                            label={formatMessage({ id: LocalizationIds.Search })}
                            value={service.search.searchText}
                            onChange={(e) => service.updateSearch({
                                ...service.search,
                                searchText: e.target.value
                            })}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            select
                            variant="standard"
                            name="filter"
                            label={formatMessage({ id: LocalizationIds.Filter })}
                            value={service.search.filter}
                            onChange={(e) => {
                                let request = {
                                    ...service.search,
                                    filter: e.target.value
                                }

                                service.updateSearch(request);
                                service.doSearch(request);
                            }}
                        >
                            <MenuItem value="All">{formatMessage({ id: LocalizationIds.All })}</MenuItem>
                            <MenuItem value="Open">{formatMessage({ id: LocalizationIds.Open })}</MenuItem>
                            <MenuItem value="Closed">{formatMessage({ id: LocalizationIds.Closed })}</MenuItem>
                        </TextField>
                    </Grid>
                    <Grid item xs={12}>
                        <Button
                            type="submit"
                            color="secondary"
                            variant="outlined"
                            aria-label="search"
                            fullWidth
                        >
                            <SearchIcon />
                        </Button>
                    </Grid>
                </FilterContainer>
            </FiltersMenu>
        </>
    );
}

export default MobileFilters;